/** statuses used when doing an ajax request */
export const FETCH_STATUS = Object.freeze({
  ERROR: 0,
  LOADING: 1,
  PENDING: 2,
  SUCCESS: 3,
})
